// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');

const requestCreditSituationInProgress = (accountId) => ({
    type: actionTypes.FETCH_CREDIT_SITUATION_REQUEST,
    payload : {
        id: accountId
    }
});

const requestCreditSituationSuccess = (accountId, response) => ({
    type: actionTypes.FETCH_CREDIT_SITUATION_SUCCESS,
    payload : {
        id: accountId,
        data: response
    }
});

const requestCreditSituationFailure = (accountId, error) => ({
    type: actionTypes.FETCH_CREDIT_SITUATION_FAILURE,
    payload : {
        id: accountId,
        error
    }
});

const requestCreditSituation = (accountId) => (dispatch, getState) => {
    const immCreditInvestment = getState().creditsInvestment;
    const isFetching = immCreditInvestment.getIn(['byId', accountId, 'creditSituation', 'isFetching']);

    if (!isFetching) {
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const accountsRequestData = {
            query: {
                producto: immAccount.get('product'),
                numeroContrato: immAccount.get('contractNumber')
            }
        };

        dispatch(requestCreditSituationInProgress(accountId));

        return APIGet(dispatch, apiURLBuilder.getURL('requestCreditSituation') , accountsRequestData)
            .then((response) => dispatch(requestCreditSituationSuccess(accountId, response)))
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestCreditSituationFailure(accountId, response.error));
                }
                else throw response;
            });
    }
};

module.exports = {
    requestCreditSituation
};
